import ahsanSajidImage from "@/assets/ahsan-sajid.png";

export const VibeCodingFounderQuote = () => {
  return (
    <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <img
          src={ahsanSajidImage}
          alt="Ahsan Sajid"
          className="w-14 h-14 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-foreground italic leading-relaxed">
            "I've watched developers ship in hours what used to take days. But speed without understanding 
            is technical debt waiting to happen. Vibe coding works for prototypes, but when someone's business 
            depends on your code, you need to understand every line. The best developers use AI to move faster, 
            not to skip learning."
          </blockquote>
          <div className="mt-4">
            <p className="font-semibold text-foreground">Ahsan Sajid</p>
            <p className="text-sm text-muted-foreground">Owner, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
